import React, { useContext } from "react";
import * as compatManager from '../../compatManager';
import { NavObjectType, NavObjectWinState, TabNames, lddGlobalSessionInfo } from "../navigationTypes";
import { useEffect } from "react";
import { NavigationContext } from "../../Context/NavigationContext";
import { useDispatch } from "react-redux";
import { ReducerEnum, setIndicators, setLenderVerified, setRoot, setShowLenderCentre, setShowUserContactList, setInboxState, setShowLenderCredentialsError, setShowChequePrinting, setEditChequeDetails, setEditChequeIndex, setShowEditFileNumberWarning, setDisplayToastMessage, setPropertyCoordinate, setShowTrustShieldExport, setShowDepositVerification, setTrustShieldIframe, setTrustShieldDiscrepancy, setTrustShieldPaymentDetails, setTrustLedgerDiff, setRealEstateBrokerState, setPurchaserRealEstateBrokerState, setShowFileDriveEmailPicker, setTransferItemSelection, setShowCosmoLexExport, setShowCosmoLexAccount } from "../../redux/reducer";
import { FileDrive_Funcs } from "../FileDrive/filedriveFuncs";
import { PSM } from "../../util/rpwTypes";
import { useAppSelector } from "../../redux/hooks";
import { getDetailsList } from "../../SideDrawer/menus/details";
import { getDataReader } from "../../livedataFuncs";
import KeyDate from "../taskSystem/KeyDate";
import { OpenNewFileDefinition } from "../../Components/fileList/fileList";
import Storage from "../../util/storage";
import { triggerSaveButtonClick } from '../../fileToolbar/fileToolbarMenuItem';
import type { TrustShieldExportPayload, TrustShieldDiscrepancyPayload, TrustLedgerDiffPayload, TransferItemSelectionPayload } from '../TrustShield/trustShieldTypes';
import type { CosmoLexExportPayload, CosmoLexAccountPayload } from '../CosmoLex/cosmoLexTypes';
import { fetchExistingTransactions, getCosmoLexExpenses } from '../CosmoLex/cosmoLexService';
import { payloadHasDifferences } from '../CosmoLex/cosmoLexDiff';
import { getCachedSubForSid, getUserManager } from '../TrustShield/oidcManager';
import { initTrustShieldSSO } from '../TrustShield/initTrustShieldSSO';
import { provisionMatter, ProvisionMatterPayload, ProvisionMatterResult, extractTrustShieldError } from '../TrustShield/trustShieldService';
import { useLaunchTransferForm } from '../TrustShield/useLaunchTransferForm';
import axios from 'axios';
import { useQueryClient } from '@tanstack/react-query';
import { PRODUCT_NAME } from "../branding";

const MainIFrame = (props: { page: NavObjectType }) => {
    const mainIFrameID = "lddIFrame";
    const nav = useContext(NavigationContext);
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const launchTransferForm = useLaunchTransferForm();
    const SESSION_INFO: lddGlobalSessionInfo = useAppSelector((g) => g.SessionInfo);
    const keyDateTasks = useAppSelector((state) => state.InFileTasks);
    const isCollege = SESSION_INFO?.firm?.IsCollege;

    function goTo(url: string): void {
        const splitIndex = url.indexOf("?");
        let file = url.substring(0, splitIndex);
        if (url.indexOf("compatshell") !== -1) {
            window.location.href = url;
        }
        if (file === 'logout.asp') {
            window.location.href = url;
            return;
        }
        const paramStr = url.substring(splitIndex + 1);
        if (file.indexOf("compathost") !== -1) {
            file = file.substring(file.indexOf("#") + 1);
        }
        let newpage: NavObjectType;
        if (paramStr) {
            const searchParams = new URLSearchParams(paramStr)
            if (file.endsWith("menu.asp")) {
                newpage = { component: 'filelist' }
            } else {
                newpage = { component: 'main', url: file, params: Object.fromEntries(searchParams) }
            }
        } else {
            newpage = { component: 'main', url: file }
        }
        nav(newpage)
    }

    function setDataRootFunc(dataRoot: Element): void {
        if (dataRoot) {
            dispatch(setRoot(dataRoot))
        }
    }

    function ActivityCentreAdd(msg, onclick, type, lddActivityCenterTracker, clearWhenOut?: boolean) {
        const eventParams = {
            detail: {
                event: "add",
                param: {
                    msg: msg,
                    onclick: onclick,
                    type: type === '' ? 'word' : type,
                    lddActivityCenterTracker: lddActivityCenterTracker,
                    clearWhenOut: clearWhenOut
                }
            }
        }
        const event = new CustomEvent("LDDActivityCentre", eventParams);
        dispatchEvent(event);
    }

    function ActivityCentreDel(counter: number) {
        const eventParams = { detail: { event: "delete", param: { counter: counter } } }
        const event = new CustomEvent("LDDActivityCentre", eventParams);
        dispatchEvent(event);
    }

    function openTPAppFromCalendar(TPAppID: string, PSM: PSM, tb: string) {
        if (TPAppID > "") {
            const newpage: NavObjectType = {
                component: 'main',
                url: 'lfmaster.asp',
                params: {
                    'formasp': (PSM === "O") ? "purfilepolaris" : "purfileedit",
                    'tb': tb,
                    'id': TPAppID,
                    'NoHeader': '1',
                    'compat': '1',
                },
            }
            nav(newpage);
        }
    }

    function useNavigateFile(appid: number, PSM: PSM, wantNewWindow = false): void {
        const navigationObj: NavObjectType = OpenNewFileDefinition(PSM, appid);
        if (wantNewWindow) {
            const sid = SESSION_INFO.sid;
            let url = "compatshell.html?SessionID=" + sid + "&params=" + encodeURIComponent(JSON.stringify(navigationObj));
            window.open(url, "_blank");
            return;
        }
        nav(navigationObj);
    }

    function useNavigateToUserSetting(): void {
        const OpenUserSettings: NavObjectType =
        {
            component: "main",
            url: "lfmaster.asp",
            popup: false,
            params: { "formasp": "EditUserCredentials" }
        };
        nav(OpenUserSettings);
    }

    function useNavigateToDocMasters(): void {
        const OpenDocMasters: NavObjectType =
        {
            component: "docmasters",
            reactFrame: "docmasters",
        };
        nav(OpenDocMasters);
    }

    function useNavigateToPackage(): void {
        const OpenPackage: NavObjectType =
        {
            component: "docmasters",
            reactFrame: "packages",
        };
        nav(OpenPackage);
    }

    function navigateToScreen(nodeIndex: number, nodeName: TabNames, listName: string, psm: string, appid: string, label: string, reactFrame?: string,): void {
        let navigateScreenObj: NavObjectType;

        getDetailsList(SESSION_INFO.appProvinceShort, SESSION_INFO.sid, isCollege).then(list => {
            const findMenuByLabel = (items: Array<any>, targetLabel: string): any => {
                for (const item of items || []) {
                    if (item?.label === targetLabel) {
                        return item;
                    }
                    const nested = findMenuByLabel(item?.subItems, targetLabel)
                        || findMenuByLabel(item?.addOptions, targetLabel)
                        || findMenuByLabel(item?.dropdownOptions, targetLabel);
                    if (nested) {
                        return nested;
                    }
                }
                return null;
            };
            const match = findMenuByLabel(list, listName);
            if (!match?.navigate) {
                console.warn("navigateToScreen: menu item not found", { listName, nodeName, nodeIndex });
                return;
            }

            navigateScreenObj = { ...match.navigate };
            const normalizedAppId = appid !== undefined && appid !== null ? String(appid).trim() : appid;
            navigateScreenObj.params = {
                formasp: 'purfileedit',
                tb: "TPAppXML",
                "id": normalizedAppId,
                "PSM": psm,
            }
            navigateScreenObj.controller = {
                tabName: nodeName,
                tabNumber: nodeIndex
            }
            navigateScreenObj.label = label;
            reactFrame > '' ? navigateScreenObj.reactFrame = reactFrame : navigateScreenObj.reactFrame = null;

            nav(navigateScreenObj);
        });
    }

    function updateShellItemView(): void {
        dispatch({
            type: ReducerEnum.SET_SIDEMENURELOAD,
            payload: new Date().getTime()
        })
    }

    function PurfileNewCreateClick(daraRoot: Element): void {
        KeyDate.SaveKeyDates(getDataReader(daraRoot), SESSION_INFO);
    }

    function openDRMsgFromInbox(MsgNode: ajaxslt.XNode): void {
        const msgId = MsgNode.getAttribute("MsgID");
        if (msgId > "" && Number(msgId)) {
            // call notifications
            dispatch(setInboxState(true, msgId));
        }
    }

    function openInboxFromMortgage(): void {
        const navigationObj: NavObjectType = {
            component: "main",
            popup: true,
            isModal: true,
            reactModalFrame: "mortimp",
        };
        nav(navigationObj);
    }

    function MyDriveIndicatorOn(): void {
        dispatch(setIndicators("MyDriveHasNewDoc", true));
    }

    function OpenAnalyzedPDF(appID: string, docName: string): void {
        Storage.viewPDF(docName, 'Analyzer', appID, SESSION_INFO);
    }
    function isLenderVerified(dataRoot: any): boolean {
        const lawyer = dataRoot.selectSingleNode('lawyer');
        const thirdPartyAccounts = lawyer.selectSingleNode('ThirdPartyAcounts');
        let telusUsername = '';
        let telusPassword = '';
        let accNumber = '';
        let assystCookies = '';

        if (thirdPartyAccounts) {
            const accounts = thirdPartyAccounts.selectNodes('Account');
            for (let i = 0; i < accounts.length; i++) {
                telusUsername = accounts[i].getAttribute('TelusUsername') || telusUsername;
                telusPassword = accounts[i].getAttribute('TelusPassword') || telusPassword;
                accNumber = accounts[i].getAttribute('AccountNumber') || accNumber;
                assystCookies = accounts[i].getAttribute('Cookies') || assystCookies;
            }
            
            const hasCredentials = telusUsername && telusPassword && accNumber;
            
            if (hasCredentials) {
                if (assystCookies) {
                    dispatch(setLenderVerified(true));
                    dispatch(setShowLenderCentre(false));
                    dispatch(setShowLenderCredentialsError(false));
                    return true;
                } else {
                    dispatch(setLenderVerified(false));
                    dispatch(setShowLenderCentre(false));
                    dispatch(setShowLenderCredentialsError(true));
                    return false;
                }
            } else {
                dispatch(setLenderVerified(false));
                dispatch(setShowLenderCentre(true));
                dispatch(setShowLenderCredentialsError(false));
                return false;
            }
        } else {
            dispatch(setLenderVerified(false));
            dispatch(setShowLenderCentre(true));
            dispatch(setShowLenderCredentialsError(false));
            return false;
        }
    }
    function ShowUserContactList(): void {
        dispatch(setShowUserContactList(true))
    }

    function ShowRealEstateBrokerList(): void {
        dispatch(setRealEstateBrokerState(true));
    }

    function ShowSellingRealEstateBrokerList(): void {
        dispatch(setPurchaserRealEstateBrokerState(true));
    }

    function OpenLenderList (): void {
        dispatch({type: ReducerEnum.SET_MORTGAGELENDER});
    }

    function OpenLawyerList (): void {
        dispatch({type: ReducerEnum.SET_LAWYERLIST});
    }

    // Opens the MyDrive file picker over the email composer. `callback` is the composer's
    // own handler; it is invoked with (docName, docExt, tempPath) once a file is uploaded.
    function OpenMyDriveAttach(callback: (docName: string, docExt: string, docPath: string) => void): void {
        FileDrive_Funcs.setEmailAttachCallback(callback);
        dispatch(setShowFileDriveEmailPicker(true));
    }

    function handleChequePrinting(): void {
        dispatch(setShowChequePrinting(true));
    }

    function handleExportToTrustShield(payload: TrustShieldExportPayload): void {
        dispatch(setShowTrustShieldExport(payload));
    }

    function handleExportToCosmoLex(payload: CosmoLexExportPayload): void {
        dispatch(setShowCosmoLexExport(payload));
    }

    function handleExportAccountToCosmoLex(payload: CosmoLexAccountPayload): void {
        dispatch(setShowCosmoLexAccount(payload));
    }

    /**
     * Trust statement banner check: compare the scraped statement against the
     * linked CosmoLex matter's transactions. One list fetch per call — the same
     * diff the export modal's Resolve Differences screen runs.
     */
    async function cosmoLexDiffStatus(
        matterId: string,
        payload: CosmoLexExportPayload
    ): Promise<'differences' | 'upToDate' | 'error'> {
        try {
            const prov = SESSION_INFO?.appProvinceShort ?? '';
            const firmId = SESSION_INFO?.firm?.id ?? 0;
            const sid = SESSION_INFO?.sid ?? '';
            if (!matterId || !sid) return 'error';
            const existing = await fetchExistingTransactions(prov, firmId, sid, matterId);
            return payloadHasDifferences(payload?.items || [], existing.items, matterId)
                ? 'differences'
                : 'upToDate';
        } catch {
            return 'error';
        }
    }

    async function cosmolexAccountDiff(
        matterId: string,
        payload: CosmoLexAccountPayload
    ): Promise<'differences' | 'upToDate' | 'noData' | 'error'> {
        try {
            const prov = SESSION_INFO?.appProvinceShort ?? '';
            const firmId = SESSION_INFO?.firm?.id ?? 0;
            const sid = SESSION_INFO?.sid ?? '';
            if (!matterId || !sid) return 'error';
            // The banner only calls this once at least one item on the page is linked (the
            // "connected, nothing sent yet" case is decided locally in CosmoLexAccntFuncs.js).
            // An empty CosmoLex list here therefore means every sent item was deleted upstream,
            // which the diff below reports as 'differences' — matching the Resolve screen the
            // modal opens for linked items.
            const existing = await getCosmoLexExpenses(prov, firmId, sid, matterId);
            const payloadItems = payload.items.filter(item => item.amountCents > 0);
            if(existing.length == 0) return 'noData';
            if(existing.length != payloadItems.length) return 'differences';
            const diff = payloadItems.map(i => {
                const cosmo = existing.find(item => item.id === i.linkedId);
                if(!cosmo) return true;
                return i.amountCents !== cosmo.amountCents || i.description !== cosmo.description;
            })
            return diff.some(a => a)
                ? 'differences'
                : 'upToDate';
        } catch {
            return 'error';
        }
    }

    function handleDepositSingleItem(payload: TrustShieldExportPayload): void {
        dispatch(setShowTrustShieldExport({ ...payload, singleItem: true, singleItemType: 'deposit' }));
    }

    function handleWithdrawalSingleItem(payload: TrustShieldExportPayload): void {
        dispatch(setShowTrustShieldExport({ ...payload, singleItem: true, singleItemType: 'withdrawal' }));
    }

    function handlePaymentSingleItem(payload: TrustShieldExportPayload): void {
        dispatch(setShowTrustShieldExport({ ...payload, singleItem: true, singleItemType: 'withdrawal' }));
    }

    function handleDisplayToastMessage(message: string, status: string): void {
        dispatch(setDisplayToastMessage(message, status));
    }

    function handleShowDepositVerification(): void {
        dispatch(setShowDepositVerification(true));
    }

    function handleOpenTrustShieldView(url: string): void {
        dispatch(setTrustShieldIframe({ url, title: PRODUCT_NAME }));
    }

    // Backward-compat bridge: older puracct builds call this directly and skip
    // the item-selection screen (no amount pre-fill). New builds call
    // topWindowTransferItemSelection instead, and the selection modal invokes the
    // same launcher (useLaunchTransferForm) with the chosen total. Keeping this
    // shim is free and protects stale iframes during a deploy window.
    function handleTransferForm(payload: {
        appId: number; fileNumber: string; clientName: string; fileCreationDate: string; amountCents?: number;
    }): void {
        void launchTransferForm(payload);
    }

    // New puracct "Transfer" entry point: show the item-selection modal so the
    // user can total up existing payment items before continuing to the trust
    // transfer surface. The modal's Continue calls launchTransferForm with the sum.
    function handleTransferItemSelection(payload: TransferItemSelectionPayload): void {
        dispatch(setTransferItemSelection(payload));
    }

    function handleShowTrustShieldDiscrepancy(payload: TrustShieldDiscrepancyPayload): void {
        dispatch(setTrustShieldDiscrepancy(payload));
    }

    // Payment Details. A separate entry point from the receipt one because the
    // webapp payment row knows statically which modal it wants, so nothing has
    // to infer the kind from the payload.
    function handleShowTrustShieldPaymentDetails(payload: TrustShieldDiscrepancyPayload): void {
        dispatch(setTrustShieldPaymentDetails(payload));
    }

    function handleShowTrustLedgerDiff(payload: TrustLedgerDiffPayload): void {
        dispatch(setTrustLedgerDiff(payload));
    }

    // Iframe-callable "the file was just saved." TrustLedgerAlertsWatcher
    // compares TrustShield records against the SAVED file XML, but its
    // ['fileXml', appId] query (shared with the closing dashboard) caches with
    // staleTime: Infinity — without this signal the Activity Centre count keeps
    // comparing against the XML from when the file was opened, while puracct's
    // per-row icons compare against the live XML, and the two drift apart.
    // The delay lets the legacy save round-trip commit before getxml.asp is
    // re-fetched; invalidation is idempotent so frequent silent saves are fine.
    function handleTrustShieldFileSaved(appId: number): void {
        if (!Number.isFinite(appId)) return;
        setTimeout(() => {
            queryClient.invalidateQueries({ queryKey: ['fileXml', appId] });
            queryClient.invalidateQueries({ queryKey: ['trustLedgerAlerts-exports', appId] });
            queryClient.invalidateQueries({ queryKey: ['trustLedgerAlerts-unlinked', appId] });
        }, 1500);
    }

    function triggerEditChequeDetails(index: string): void {
        dispatch(setEditChequeIndex(index));
        dispatch(setEditChequeDetails(true));
    }

    function ShowEditFileNumberWarning(): void {
        dispatch(setShowEditFileNumberWarning(true));
    }

    function saveFileViaButton(): void {
        triggerSaveButtonClick();
    }

    function updatePropertyCoordinate(coordinate: string): void {
        dispatch(setPropertyCoordinate(coordinate));
    }

    // Returns the current SessionID for iframe scripts (e.g., TrustShield integration)
    function getSessionID(): string | null {
        return SESSION_INFO?.sid || null;
    }

    // Returns the OIDC `sub` for the current SessionID once ReactShell has
    // resolved it (via /oidc/trusted-token on the first initTrustShieldSSO
    // call). Legacy iframe scripts use this to locate the right
    // ts-<sub>:oidc.user:... token partition without needing their own
    // sid→sub map in localStorage.
    function getTrustShieldSub(): string | null {
        const sid = SESSION_INFO?.sid;
        return sid ? getCachedSubForSid(sid) : null;
    }

    // Iframe-callable "refresh the TrustShield tokens for the current UV
    // session." Awaited by legacy ASP preAuthenticate when it sees a stale
    // token. `initTrustShieldSSO` dedupes concurrent calls for the same sid
    // (in-flight Map), so the iframe and useTrustShieldAuth share one
    // /trusted-token round trip and both see the fresh localStorage entry.
    async function ensureTrustShieldToken(): Promise<void> {
        const sid = SESSION_INFO?.sid;
        if (!sid) return;
        await initTrustShieldSSO(sid);
    }

    // Iframe-callable: pre-create the matter on the TrustShield side as soon
    // as a Realti matter is created (purfilenew save). The TrustShield endpoint
    // is idempotent (findOrCreate on [tenant, file_number]); legacy callers
    // should await this but MUST NOT block the Realti save on failure — the
    // JIT fallback in TrustShield still creates the matter on first transaction.
    // Returns a result object; never throws.
    async function provisionTrustShieldMatter(
        payload: ProvisionMatterPayload
    ): Promise<{ ok: boolean; result?: ProvisionMatterResult; error?: string; status?: number }> {
        const sid = SESSION_INFO?.sid;
        if (!sid) {
            console.warn('[TrustShield] provision: no SessionID, skipping');
            return { ok: false, error: 'No SessionID' };
        }
        const sub = await initTrustShieldSSO(sid);
        if (!sub) {
            console.warn('[TrustShield] provision: could not obtain OIDC sub, skipping');
            return { ok: false, error: 'No OIDC sub' };
        }
        const user = await getUserManager(sub).getUser();
        const jwt = user && !user.expired ? user.access_token : null;
        if (!jwt) {
            console.warn('[TrustShield] provision: no valid access_token in storage, skipping');
            return { ok: false, error: 'No access token' };
        }
        try {
            const result = await provisionMatter(jwt, payload);
            return { ok: true, result };
        } catch (err) {
            if (axios.isAxiosError(err) && err.response && err.response.status >= 400 && err.response.status < 500) {
                console.error('[TrustShield] provision failed with', err.response.status, '— not retrying (4xx is a bug):', err.response.data);
                return { ok: false, error: extractTrustShieldError(err, 'Provision failed'), status: err.response.status };
            }
            console.warn('[TrustShield] provision failed, retrying once:', err);
            try {
                const result = await provisionMatter(jwt, payload);
                return { ok: true, result };
            } catch (err2) {
                console.error('[TrustShield] provision failed after retry — TrustShield JIT fallback will run on first transaction:', err2);
                return { ok: false, error: extractTrustShieldError(err2, 'Provision failed') };
            }
        }
    }

    useEffect(() => {
        compatManager.init(document.getElementById(mainIFrameID), {
            serviceObjs:
            {
                'topWindowLddCentralNavigateAway': goTo,
                'topWindowLddSetDataRoot': setDataRootFunc,
                'topWindowlddActivityCenterAdd': ActivityCentreAdd,
                'topWindowlddActivityCenterDelete': ActivityCentreDel,
                'topWindowOpenTPAppFromCalendar': openTPAppFromCalendar,
                'topWindowNavigateToFile': useNavigateFile,
                'topWindowNavigateToUserSetting': useNavigateToUserSetting,
                'topWindowNavigateToScreen': navigateToScreen,
                'topWindowNavigateToDocMasters': useNavigateToDocMasters,
                'topWindowNavigateToPackage': useNavigateToPackage,
                'topWindowUpdateShellItemView': updateShellItemView,
                'topWindowPurfileNewCreateClick': PurfileNewCreateClick,
                'topWindowOpenDRMsgFromInbox': openDRMsgFromInbox,
                'topWindowMyDriveIndicatorOn': MyDriveIndicatorOn,
                'topWindowOpenAnalyzedPDF': OpenAnalyzedPDF,
                'topWindowIsLenderVerified': isLenderVerified,
                'topWindowShowUserContactList': ShowUserContactList,
                'topWindowShowRealEstateBrokerList': ShowRealEstateBrokerList,
                'topWindowShowSellingRealEstateBrokerList': ShowSellingRealEstateBrokerList,
                'topWindowOpenLenderList': OpenLenderList,
                'topWindowOpenLawyerList': OpenLawyerList,
                'topWindowOpenInboxFromMortgage': openInboxFromMortgage,
                'topWindowHandleChequePrinting': handleChequePrinting,
                'topWindowTriggerEditChequeDetails': triggerEditChequeDetails,
                'topWindowOpenEditFileNumberWarning': ShowEditFileNumberWarning,
                'topWindowSaveFileWithKeyDates': saveFileViaButton,
                'topWindowHandleDisplayToastMessage': handleDisplayToastMessage,
                'topWindowSetPropertyCoordinate' : updatePropertyCoordinate,
                'topWindowOpenMyDriveAttach': OpenMyDriveAttach,
                'topWindowGetSessionID': getSessionID,
                'topWindowGetTrustShieldSub': getTrustShieldSub,
                'topWindowEnsureTrustShieldToken': ensureTrustShieldToken,
                'topWindowProvisionTrustShieldMatter': provisionTrustShieldMatter,
                'topWindowExportToTrustShield': handleExportToTrustShield,
                'topWindowExportToCosmoLex': handleExportToCosmoLex,
                'topWindowExportAccountToCosmoLex': handleExportAccountToCosmoLex,
                'topWindowCosmoLexDiffStatus': cosmoLexDiffStatus,
                'topWindowCosmoLexAccountDiff' : cosmolexAccountDiff,
                'topWindowDepositSingleItem': handleDepositSingleItem,
                'topWindowWithdrawalSingleItem': handleWithdrawalSingleItem,
                'topWindowPaymentSingleItem': handlePaymentSingleItem,
                'topWindowShowDepositVerification': handleShowDepositVerification,
                'topWindowOpenTrustShieldView': handleOpenTrustShieldView,
                'topWindowTransferForm': handleTransferForm,
                'topWindowTransferItemSelection': handleTransferItemSelection,
                'topWindowShowTrustShieldDiscrepancy': handleShowTrustShieldDiscrepancy,
                'topWindowShowTrustShieldPaymentDetails': handleShowTrustShieldPaymentDetails,
                'topWindowShowTrustLedgerDiff': handleShowTrustLedgerDiff,
                'topWindowTrustShieldFileSaved': handleTrustShieldFileSaved,
            }
        }, nav);
        nav({ ...props.page, init: true });
    }, [])
    return (
        <div id={mainIFrameID} className="justify-content-center text-center iframeBox" />
    );
}
export default MainIFrame;

export function navigateNewPage(navigation: NavObjectType, sid: string, winObj?: NavObjectWinState,): any {
    //Probably harder to work with URL obj since compathost stores everything in hash 
    //Need to move SessionID check out of here, and remove SessionID completely from string, and set it while loading frames
    let url: string | 1 | -1 = navObjectToURLstring(navigation, sid);
    if (typeof url === "string") {
        if (navigation.popup) {
            return compatManager.navigatePopupPage(url, navigation.popupStyle, navigation.isModal, winObj.dialogArguments);
        } else {
            console.assert(!winObj || !winObj.dialogArguments);
            return compatManager.navigateNewPage(url, winObj);
        }
    } else {
        compatManager.navigateNewPage(url)
    }
}

export function navObjectToURLstring(navigation: NavObjectType, sid: string): any {
    let url: string | 1 | -1 = navigation.url;
    if (typeof url === "string") {
        const params = new URLSearchParams(navigation.params)
        if (params && Array.from(params).length) {
            url = url + (url.indexOf("?") === -1 ? "?" : "&") + params.toString()
        }
        if (url.indexOf("SessionID=") === -1) {
            url = url + (url.indexOf("?") === -1 ? "?" : "&") + "SessionID=" + sid
        }
    }
    return url
}